module.exports = __webpack_public_path__ + "img/T09.0aa3cd11.jpg";